var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBxHeartTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.18584 2.90144C6.60732 2.36948 5.85008 2.07424 5.06417 2.07422C4.64819 2.07465 4.23641 2.15734 3.85251 2.31754C3.46862 2.47773 3.12019 2.71226 2.82728 3.00763C1.57796 4.26226 1.57849 6.22464 2.82835 7.47396L6.72126 11.3669C6.81152 11.5256 6.98567 11.6281 7.18584 11.6281C7.26803 11.6273 7.34889 11.6072 7.42192 11.5695C7.49495 11.5318 7.55812 11.4775 7.60635 11.4109L11.5433 7.47396C12.7932 6.22411 12.7932 4.26226 11.5423 3.0055C11.2495 2.71068 10.9014 2.47662 10.5178 2.3168C10.1343 2.15698 9.723 2.07454 9.30751 2.07422C8.52161 2.07435 7.76442 2.36957 7.18584 2.90144ZM10.7915 3.75626C11.6214 4.59038 11.6219 5.89333 10.7926 6.7232L7.18584 10.3299L3.57911 6.7232C2.74977 5.89333 2.7503 4.59038 3.57805 3.75839C3.98157 3.35699 4.50933 3.13612 5.06417 3.13612C5.61901 3.13612 6.14465 3.35699 6.54498 3.75732L6.81046 4.0228C6.85972 4.07215 6.91824 4.1113 6.98265 4.13801C7.04706 4.16472 7.11611 4.17847 7.18584 4.17847C7.25557 4.17847 7.32462 4.16472 7.38903 4.13801C7.45344 4.1113 7.51195 4.07215 7.56122 4.0228L7.82669 3.75732C8.62949 2.95612 9.98978 2.95825 10.7915 3.75626Z",
    fill: "#9CA3AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxHeartTwitter);
export default __webpack_public_path__ + "static/media/bx-heart-twitter.031197f75c24fd0c6036ac5704bd0c6c.svg";
export { ForwardRef as ReactComponent };